/*
 * Copyright French Prime minister Office/SGMAP/DINSIC/Vitam Program (2019-2022)
 * and the signatories of the "VITAM - Accord du Contributeur" agreement.
 *
 * contact@programmevitam.fr
 *
 * This software is a computer program whose purpose is to implement
 * implement a digital archiving front-office system for the secure and
 * efficient high volumetry VITAM solution.
 *
 * This software is governed by the CeCILL-C license under French law and
 * abiding by the rules of distribution of free software.  You can  use,
 * modify and/ or redistribute the software under the terms of the CeCILL-C
 * license as circulated by CEA, CNRS and INRIA at the following URL
 * "http://www.cecill.info".
 *
 * As a counterpart to the access to the source code and  rights to copy,
 * modify and redistribute granted by the license, users are provided only
 * with a limited warranty  and the software's author,  the holder of the
 * economic rights,  and the successive licensors  have only  limited
 * liability.
 *
 * In this respect, the user's attention is drawn to the risks associated
 * with loading,  using,  modifying and/or developing or reproducing the
 * software by the user in light of its specific status of free software,
 * that may mean  that it is complicated to manipulate,  and  that  also
 * therefore means  that it is reserved for developers  and  experienced
 * professionals having in-depth computer knowledge. Users are therefore
 * encouraged to load and test the software's suitability as regards their
 * requirements in conditions enabling the security of their systems and/or
 * data to be ensured and,  more generally, to use and operate it in the
 * same conditions as regards security.
 *
 * The fact that you are presently reading this means that you have had
 * knowledge of the CeCILL-C license and that you accept its terms.
 */
export enum ApplicationId {
  DESIGN_SYSTEM_APP = 'DESIGN_SYSTEM_APP',
  PORTAL_APP = 'PORTAL_APP',
  CUSTOMERS_APP = 'CUSTOMERS_APP',
  USERS_APP = 'USERS_APP',
  GROUPS_APP = 'GROUPS_APP',
  PROFILES_APP = 'PROFILES_APP',
  SUBROGATIONS_APP = 'SUBROGATIONS_APP',
  ACCOUNTS_APP = 'ACCOUNTS_APP',
  HIERARCHY_PROFILE_APP = 'HIERARCHY_PROFILE_APP',
  INGEST_APP = 'INGEST_MANAGEMENT_APP',
  ARCHIVE_SEARCH_APP = 'ARCHIVE_SEARCH_MANAGEMENT_APP',
  PERSISTENT_IDENTIFIER_SEARCH_APP = 'PERSISTENT_IDENTIFIER_SEARCH_APP',
  PASTIS_APP = 'PASTIS_APP',
  RULES_APP = 'RULES_APP',
  HOLDING_FILLING_SCHEME_APP = 'HOLDING_FILLING_SCHEME_APP',
  LOGBOOK_OPERATION_APP = 'LOGBOOK_OPERATION_APP',
  PROBATIVE_VALUE_APP = 'PROBATIVE_VALUE_APP',
  DSL_APP = 'DSL_APP',
  SECURE_APP = 'SECURE_APP',
  AUDIT_APP = 'AUDIT_APP',
  ONTOLOGY_APP = 'ONTOLOGY_APP',
  PRESERVATION_APP = 'PRESERVATION_APP',
  SECURITY_PROFILES_APP = 'SECURITY_PROFILES_APP',
  CONTEXTS_APP = 'CONTEXTS_APP',
  FILE_FORMATS_APP = 'FILE_FORMATS_APP',
  AGENCIES_APP = 'AGENCIES_APP',
  ACCESS_APP = 'ACCESS_APP',
  INGEST_APP_REF = 'INGEST_APP',
  LOGBOOK_MANAGEMENT_OPERATION_APP = 'LOGBOOK_MANAGEMENT_OPERATION_APP',
  EXTERNAL_PARAM_PROFILE_APP = 'EXTERNAL_PARAM_PROFILE_APP',
  EXTERNAL_PARAMS = 'EXTERNAL_PARAMS',
  MANAGEMENT_CONTRACT_APP = 'MANAGEMENT_CONTRACT_APP',
  COLLECT_APP = 'COLLECT_APP',
}
